export default function emailIsValidish(email: string): boolean {
  // we don't care to be super strict here as the intent is to lookup
  // the users email. Just ensure it follows a basic email structure (permissive)
  return /\S+@\S+\.\S+/.test(email);
}
